import { jsxs, jsx } from 'react/jsx-runtime';
import { shallow as shallow$1 } from '../../node_modules/zustand/esm/shallow.js';
import ToastDisplay from './ToastDisplay/ToastDisplay.js';
import WarningDisplay from './WarningDisplay/WarningDisplay.js';
import BannerDisplay from './BannerDisplay/BannerDisplay.js';
import { AnimatePresence } from 'framer-motion';
import ConfirmDisplay from './ConfirmDisplay/ConfirmDisplay.js';
import UpgradePromptDisplay from './UpgradePromptDisplay/UpgradePromptDisplay.js';
import { styled } from 'styled-components';
import useAlertStore from '../store/alerts.js';
import PromptDisplay from './PromptDisplay/PromptDisplay.js';
import { useSubscriptionLimitBanner } from '../pricing/hooks/useSubscriptionLimitBanner.js';
import { usePlatform } from '@fabric-app/compat/capabilities/platform';

const Container = styled.div.withConfig({
  displayName: "AlertInterface__Container",
  componentId: "sc-ad1cf9bd-0"
})([
  `position:fixed;top:60px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:8px;z-index:200;`
]);
const BannersContainer = styled.div.withConfig({
  displayName: "AlertInterface__BannersContainer",
  componentId: "sc-ad1cf9bd-1"
})([
  `flex-shrink:0;width:100%;overflow:hidden;`
]);
const isToast = (alert) => alert.type === "toast";
const isWarning = (alert) => alert.type === "warning";
const isConfirm = (alert) => alert.type === "confirm";
const isPrompt = (alert) => alert.type === "prompt";
const isUpgradePrompt = (alert) => alert.type === "upgrade_prompt";
const mapToElements = (alert) => {
  if (isToast(alert)) {
    return /* @__PURE__ */ jsx(ToastDisplay, {
      alert
    }, alert.id);
  } else if (isWarning(alert)) {
    return /* @__PURE__ */ jsx(WarningDisplay, {
      alert
    }, alert.id);
  } else if (isUpgradePrompt(alert)) {
    return /* @__PURE__ */ jsx(UpgradePromptDisplay, {
      alert
    }, alert.id);
  } else if (isConfirm(alert)) {
    return /* @__PURE__ */ jsx(ConfirmDisplay, {
      alert
    }, alert.id);
  } else if (isPrompt(alert)) {
    return /* @__PURE__ */ jsx(PromptDisplay, {
      alert
    }, alert.id);
  } else {
    return null;
  }
};
const AlertInterface = ({ bannerDisabled = false, alertsDisabled = false, modalAlertsDisabled = false }) => {
  const clampedAlerts = useAlertStore((state) => state.alerts.filter((alert) => alert.type !== "banner" && alert.type !== "confirm" && alert.type !== "upgrade_prompt" && alert.type !== "prompt"), shallow$1);
  const platform = usePlatform();
  const disabledSubscriptionLimitBanner = platform === "chrome-extension";
  const modalAlerts = useAlertStore((state) => state.alerts.filter((alert) => isUpgradePrompt(alert) || isConfirm(alert) || isPrompt(alert)), shallow$1);
  const banner = useAlertStore((state) => state.banner);
  const { banner: subscriptionLimitBanner, dismiss: dismissSubscriptionLimitBanner } = useSubscriptionLimitBanner({
    disabled: disabledSubscriptionLimitBanner
  });
  return /* @__PURE__ */ jsxs(AnimatePresence, {
    children: [
      /* @__PURE__ */ jsxs(BannersContainer, {
        children: [
          banner && !bannerDisabled && /* @__PURE__ */ jsx(BannerDisplay, {
            alert: banner
          }, banner.id),
          subscriptionLimitBanner && /* @__PURE__ */ jsx(BannerDisplay, {
            alert: subscriptionLimitBanner,
            dismissBanner: dismissSubscriptionLimitBanner
          }, subscriptionLimitBanner.id)
        ]
      }, "banners"),
      !alertsDisabled && /* @__PURE__ */ jsx(Container, {
        children: /* @__PURE__ */ jsx(AnimatePresence, {
          children: clampedAlerts.slice(0, 5).map(mapToElements)
        })
      }, "alerts"),
      !modalAlertsDisabled && modalAlerts.map((alert) => mapToElements(alert))
    ]
  });
};

export { AlertInterface as default };
//# sourceMappingURL=AlertInterface.js.map
